export const itemsOnPage = 10;

export const statusItems = [
  { value: 'win', name: 'win', active: false },
  { value: 'lost', name: 'lose', active: false },
  { value: 'pending', name: 'notCalculated', active: false },
  { value: 'sold', name: 'sold', active: false },
];
